module.exports = __webpack_public_path__ + "img/domik_white_logo.63dcf672.svg";